/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentBracketTypeOption } from './TournamentBracketTypeOption';
import {
    TournamentBracketTypeOptionFromJSON,
    TournamentBracketTypeOptionFromJSONTyped,
    TournamentBracketTypeOptionToJSON,
    TournamentBracketTypeOptionToJSONTyped,
} from './TournamentBracketTypeOption';
import type { TournamentCategoryOption } from './TournamentCategoryOption';
import {
    TournamentCategoryOptionFromJSON,
    TournamentCategoryOptionFromJSONTyped,
    TournamentCategoryOptionToJSON,
    TournamentCategoryOptionToJSONTyped,
} from './TournamentCategoryOption';
import type { TournamentSkillLevelOption } from './TournamentSkillLevelOption';
import {
    TournamentSkillLevelOptionFromJSON,
    TournamentSkillLevelOptionFromJSONTyped,
    TournamentSkillLevelOptionToJSON,
    TournamentSkillLevelOptionToJSONTyped,
} from './TournamentSkillLevelOption';
import type { TournamentBestOfOption } from './TournamentBestOfOption';
import {
    TournamentBestOfOptionFromJSON,
    TournamentBestOfOptionFromJSONTyped,
    TournamentBestOfOptionToJSON,
    TournamentBestOfOptionToJSONTyped,
} from './TournamentBestOfOption';
import type { TournamentTimerConfig } from './TournamentTimerConfig';
import {
    TournamentTimerConfigFromJSON,
    TournamentTimerConfigFromJSONTyped,
    TournamentTimerConfigToJSON,
    TournamentTimerConfigToJSONTyped,
} from './TournamentTimerConfig';
import type { TournamentPlatformOption } from './TournamentPlatformOption';
import {
    TournamentPlatformOptionFromJSON,
    TournamentPlatformOptionFromJSONTyped,
    TournamentPlatformOptionToJSON,
    TournamentPlatformOptionToJSONTyped,
} from './TournamentPlatformOption';
import type { TournamentLateRegistrationOption } from './TournamentLateRegistrationOption';
import {
    TournamentLateRegistrationOptionFromJSON,
    TournamentLateRegistrationOptionFromJSONTyped,
    TournamentLateRegistrationOptionToJSON,
    TournamentLateRegistrationOptionToJSONTyped,
} from './TournamentLateRegistrationOption';
import type { TournamentPrivacyOption } from './TournamentPrivacyOption';
import {
    TournamentPrivacyOptionFromJSON,
    TournamentPrivacyOptionFromJSONTyped,
    TournamentPrivacyOptionToJSON,
    TournamentPrivacyOptionToJSONTyped,
} from './TournamentPrivacyOption';
import type { TournamentTeamSizeOption } from './TournamentTeamSizeOption';
import {
    TournamentTeamSizeOptionFromJSON,
    TournamentTeamSizeOptionFromJSONTyped,
    TournamentTeamSizeOptionToJSON,
    TournamentTeamSizeOptionToJSONTyped,
} from './TournamentTeamSizeOption';
import type { TournamentRefundPolicy } from './TournamentRefundPolicy';
import {
    TournamentRefundPolicyFromJSON,
    TournamentRefundPolicyFromJSONTyped,
    TournamentRefundPolicyToJSON,
    TournamentRefundPolicyToJSONTyped,
} from './TournamentRefundPolicy';
import type { TournamentRegionOption } from './TournamentRegionOption';
import {
    TournamentRegionOptionFromJSON,
    TournamentRegionOptionFromJSONTyped,
    TournamentRegionOptionToJSON,
    TournamentRegionOptionToJSONTyped,
} from './TournamentRegionOption';

/**
 * 
 * @export
 * @interface UpdateTournamentSettingsBody
 */
export interface UpdateTournamentSettingsBody {
    /**
     * 
     * @type {Array<TournamentPlatformOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    platforms?: Array<TournamentPlatformOption>;
    /**
     * 
     * @type {Array<TournamentRegionOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    regions?: Array<TournamentRegionOption>;
    /**
     * 
     * @type {Array<TournamentTeamSizeOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    teamSizes?: Array<TournamentTeamSizeOption>;
    /**
     * 
     * @type {Array<TournamentBracketTypeOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    bracketTypes?: Array<TournamentBracketTypeOption>;
    /**
     * 
     * @type {Array<TournamentPrivacyOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    privacyOptions?: Array<TournamentPrivacyOption>;
    /**
     * 
     * @type {Array<TournamentSkillLevelOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    skillLevels?: Array<TournamentSkillLevelOption>;
    /**
     * 
     * @type {TournamentTimerConfig}
     * @memberof UpdateTournamentSettingsBody
     */
    timerConfig?: TournamentTimerConfig;
    /**
     * 
     * @type {TournamentRefundPolicy}
     * @memberof UpdateTournamentSettingsBody
     */
    refundPolicy?: TournamentRefundPolicy;
    /**
     * 
     * @type {Array<TournamentLateRegistrationOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    lateRegistrationOptions?: Array<TournamentLateRegistrationOption>;
    /**
     * 
     * @type {Array<TournamentBestOfOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    bestOfOptions?: Array<TournamentBestOfOption>;
    /**
     * 
     * @type {Array<TournamentCategoryOption>}
     * @memberof UpdateTournamentSettingsBody
     */
    categoryOptions?: Array<TournamentCategoryOption>;
}

/**
 * Check if a given object implements the UpdateTournamentSettingsBody interface.
 */
export function instanceOfUpdateTournamentSettingsBody(value: object): value is UpdateTournamentSettingsBody {
    return true;
}

export function UpdateTournamentSettingsBodyFromJSON(json: any): UpdateTournamentSettingsBody {
    return UpdateTournamentSettingsBodyFromJSONTyped(json, false);
}

export function UpdateTournamentSettingsBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTournamentSettingsBody {
    if (json == null) {
        return json;
    }
    return {
        
        'platforms': json['platforms'] == null ? undefined : ((json['platforms'] as Array<any>).map(TournamentPlatformOptionFromJSON)),
        'regions': json['regions'] == null ? undefined : ((json['regions'] as Array<any>).map(TournamentRegionOptionFromJSON)),
        'teamSizes': json['teamSizes'] == null ? undefined : ((json['teamSizes'] as Array<any>).map(TournamentTeamSizeOptionFromJSON)),
        'bracketTypes': json['bracketTypes'] == null ? undefined : ((json['bracketTypes'] as Array<any>).map(TournamentBracketTypeOptionFromJSON)),
        'privacyOptions': json['privacyOptions'] == null ? undefined : ((json['privacyOptions'] as Array<any>).map(TournamentPrivacyOptionFromJSON)),
        'skillLevels': json['skillLevels'] == null ? undefined : ((json['skillLevels'] as Array<any>).map(TournamentSkillLevelOptionFromJSON)),
        'timerConfig': json['timerConfig'] == null ? undefined : TournamentTimerConfigFromJSON(json['timerConfig']),
        'refundPolicy': json['refundPolicy'] == null ? undefined : TournamentRefundPolicyFromJSON(json['refundPolicy']),
        'lateRegistrationOptions': json['lateRegistrationOptions'] == null ? undefined : ((json['lateRegistrationOptions'] as Array<any>).map(TournamentLateRegistrationOptionFromJSON)),
        'bestOfOptions': json['bestOfOptions'] == null ? undefined : ((json['bestOfOptions'] as Array<any>).map(TournamentBestOfOptionFromJSON)),
        'categoryOptions': json['categoryOptions'] == null ? undefined : ((json['categoryOptions'] as Array<any>).map(TournamentCategoryOptionFromJSON)),
    };
}

export function UpdateTournamentSettingsBodyToJSON(json: any): UpdateTournamentSettingsBody {
    return UpdateTournamentSettingsBodyToJSONTyped(json, false);
}

export function UpdateTournamentSettingsBodyToJSONTyped(value?: UpdateTournamentSettingsBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platforms': value['platforms'] == null ? undefined : ((value['platforms'] as Array<any>).map(TournamentPlatformOptionToJSON)),
        'regions': value['regions'] == null ? undefined : ((value['regions'] as Array<any>).map(TournamentRegionOptionToJSON)),
        'teamSizes': value['teamSizes'] == null ? undefined : ((value['teamSizes'] as Array<any>).map(TournamentTeamSizeOptionToJSON)),
        'bracketTypes': value['bracketTypes'] == null ? undefined : ((value['bracketTypes'] as Array<any>).map(TournamentBracketTypeOptionToJSON)),
        'privacyOptions': value['privacyOptions'] == null ? undefined : ((value['privacyOptions'] as Array<any>).map(TournamentPrivacyOptionToJSON)),
        'skillLevels': value['skillLevels'] == null ? undefined : ((value['skillLevels'] as Array<any>).map(TournamentSkillLevelOptionToJSON)),
        'timerConfig': TournamentTimerConfigToJSON(value['timerConfig']),
        'refundPolicy': TournamentRefundPolicyToJSON(value['refundPolicy']),
        'lateRegistrationOptions': value['lateRegistrationOptions'] == null ? undefined : ((value['lateRegistrationOptions'] as Array<any>).map(TournamentLateRegistrationOptionToJSON)),
        'bestOfOptions': value['bestOfOptions'] == null ? undefined : ((value['bestOfOptions'] as Array<any>).map(TournamentBestOfOptionToJSON)),
        'categoryOptions': value['categoryOptions'] == null ? undefined : ((value['categoryOptions'] as Array<any>).map(TournamentCategoryOptionToJSON)),
    };
}

